module.exports = __webpack_public_path__ + "static/6305-woodrose-41-9fc9b058cef0e21467397a0115c933ba.jpg";